import React, { useState, FormEvent } from "react";
import { Modal } from "../ui/modal";
import Button from "../ui/button/Button";
import type { AgenciaB2B } from "../../hooks/useApi";

interface CreateAgencyModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddAgency: (agency: Omit<AgenciaB2B, "id" | "reservations">) => Promise<AgenciaB2B>;
  onSuccess?: (newAgency: AgenciaB2B) => void;
}

const CreateAgencyModal: React.FC<CreateAgencyModalProps> = ({
  isOpen,
  onClose,
  onAddAgency,
  onSuccess
}) => {
  const [newAgencyData, setNewAgencyData] = useState({
    name: "",
    email: "",
    phone: "",
    rncEmpresa: "",
    responsable: "",
  });

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    
    try {
      if (!newAgencyData.name || !newAgencyData.email || !newAgencyData.phone) {
        window.alert("Por favor complete todos los campos requeridos");
        return;
      }

      const newAgency = await onAddAgency({
        ...newAgencyData,
        rncEmpresa: newAgencyData.rncEmpresa || undefined,
        responsable: newAgencyData.responsable || undefined,
        active: true
      });

      setNewAgencyData({
        name: "",
        email: "",
        phone: "",
        rncEmpresa: "",
        responsable: "",
      });

      if (newAgency) {
        onSuccess?.(newAgency);
      }
      onClose();
    } catch (error) {
      console.error("Error al crear agencia:", error);
      window.alert(error instanceof Error ? error.message : "Error al crear la agencia");
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Crear nueva agencia">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Nombre de la agencia
          </label>
          <input
            type="text"
            value={newAgencyData.name}
            onChange={(e) => setNewAgencyData({ ...newAgencyData, name: e.target.value })}
            className="mt-1 block w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-brand-500 focus:border-brand-500"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Responsable
          </label>
          <input
            type="text"
            value={newAgencyData.responsable}
            onChange={(e) => setNewAgencyData({ ...newAgencyData, responsable: e.target.value })}
            className="mt-1 block w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-brand-500 focus:border-brand-500"
            placeholder="Nombre del responsable de la agencia"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Correo electrónico
          </label>
          <input
            type="email"
            value={newAgencyData.email}
            onChange={(e) => setNewAgencyData({ ...newAgencyData, email: e.target.value })}
            className="mt-1 block w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-brand-500 focus:border-brand-500"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Teléfono
          </label>
          <input
            type="tel"
            value={newAgencyData.phone}
            onChange={(e) => setNewAgencyData({ ...newAgencyData, phone: e.target.value })}
            className="mt-1 block w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-brand-500 focus:border-brand-500"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            RNC Empresa
          </label>
          <input
            type="text"
            value={newAgencyData.rncEmpresa}
            onChange={(e) => setNewAgencyData({ ...newAgencyData, rncEmpresa: e.target.value })}
            className="mt-1 block w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-brand-500 focus:border-brand-500"
            placeholder="Ingrese el RNC de la empresa"
          />
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <Button variant="outline" type="button" onClick={onClose}>
            Cancelar
          </Button>
          <Button variant="primary" type="submit">
            Crear agencia
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default CreateAgencyModal; 